import React from 'react';
import "./SingleBannerDesktop.scss";
import {Col, Row} from "antd";
import {LazyImage} from "../../../Components";
import {useHistory} from "react-router";

const style = {
    background: '#0092ff'
};

function SingleBannerDesktop ({item,LinkDispatcher}){
    const history = useHistory()
    return(
        <Row gutter={[16,4]} justify="center" className="component-row">
            <Col xs={{ span: 16 }} sm={{ span: 16 }} md={{ span: 16 }} lg={{ span: 18}} >
                <div key={item.items[0].uid} className="single-bar pointer"
                     onClick={() => {
                         let res = item.items[0].link_to_uid.replace("online-store-categories","shop")
                         history.push(res)
                         // LinkDispatcher(item.items[0].link_to, item.items[0])
                     }
                     }>
                    <>
                        {/*<img  src={item.items[0].image} alt=""/>*/}
                        <LazyImage type={'banner'} src={item.items[0].image_desktop}/>
                        <span className="block-title">{item.items[0].title}</span>
                    </>
                </div>
            </Col>
        </Row>
    )
}

export default SingleBannerDesktop;
